module.exports = __webpack_public_path__ + "static/6-a129c01860c0020285ec9ea1e56d0ae8.jpg";